import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TidService } from '../../services/tid.service';

@Component({
  selector: 'app-tid-logout',
  templateUrl: './tid-logout.component.html',
})
export class TidLogoutComponent implements OnInit {
  @HostBinding('class') class = 'h-100';
  logoutUrl = `${environment.trimbleCloudUrl}logout`;
  logoutRedirect = `post_logout_redirect_uri=${location.origin}/login`;
  constructor(private tidService: TidService, private router: Router) {}

  ngOnInit() {
    const token = this.tidService.getIdToken();
    if (typeof token === 'string' && token.length > 0) {
      const authCode = this.tidService.getAuthCode();
      this.tidService.removeAuthCode();
      this.tidService.removeIdToken();
      if (!authCode || !token) {
        return;
      }
      window.location.href = `${this.logoutUrl}?id_token_hint=${token}&${this.logoutRedirect}`;
    } else {
      this.router.navigate(['/login']);
    }
  }
}
